import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import messages from './local/index';

// LanguageDetector 依赖浏览器 navigator，服务端渲染时跳过
const instance = typeof window === 'undefined' ? i18n : i18n.use(LanguageDetector);

instance
  .use(initReactI18next)
  .init({
    lng: 'en',
    fallbackLng: 'en',
    debug: false,
    resources: messages,
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;